var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticStyle:{"background-color":"#E5E5E5"}},[_c('v-fade-transition',{attrs:{"mode":"out-in"}},[(_vm.loading)?_c('app-loading',{attrs:{"loading":_vm.loading}}):_vm._e(),_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }